import {
  Grid,
} from '@cloudscape-design/components';
import {
  BoolStatus,
  formatEnum,
  formatVacuumFeedback,
  Value,
} from 'features/plc/components/common';
import {
  getPathName,
  PLC_PATHS,
  VACUUM_ZONE_LABELS,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValues } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

const getProcessStatusFields = ({ showVacuumPressure }) => ([
  { label: 'Safety OK', path: PLC_PATHS.status.safetyOk, kind: 'bool' },
  { label: 'Cycle Running', path: PLC_PATHS.status.cycleRunning, kind: 'bool' },
  { label: 'Vacuum Power On', path: PLC_PATHS.status.vacuumPowerOn, kind: 'bool' },
  {
    label: 'Vacuum Zone Open',
    path: PLC_PATHS.status.vacuumZoneOpen,
    formatter: (value) => formatEnum(value, VACUUM_ZONE_LABELS),
  },
  { label: 'Ionizer On', path: PLC_PATHS.status.ionizerOn, kind: 'bool' },
  ...(showVacuumPressure
    ? [{
      label: 'Vacuum Pressure',
      path: PLC_PATHS.status.pressInputs.vacuum4to20mAFeedback,
      formatter: formatVacuumFeedback,
    }]
    : []),
]);

const renderField = (field, values) => {
  const value = values[getPathName(field.path)];

  if (field.kind === 'bool') {
    return (
      <BoolStatus
        key={getPathName(field.path)}
        label={field.label}
        value={value}
      />
    );
  }

  return (
    <Value
      key={getPathName(field.path)}
      label={field.label}
      value={field.formatter ? field.formatter(value) : (value ?? '--')}
    />
  );
};

function ProcessStatus({
  showVacuumPressure = true,
}) {
  const fields = getProcessStatusFields({ showVacuumPressure });
  const values = usePLCValues(fields.map((field) => field.path));

  return (
    <Grid
      gridDefinition={[
        { colspan: 6 }, { colspan: 6 },
        { colspan: 6 }, { colspan: 6 },
        { colspan: 6 }, { colspan: 6 },
      ]}
    >
      {fields.map((field) => renderField(field, values))}
    </Grid>
  );
}

ProcessStatus.propTypes = {
  showVacuumPressure: PropTypes.bool,
};

export default ProcessStatus;
